module.exports = __webpack_public_path__ + "static/image/product-related.svg?1c0a713ce77868791fb6d07f9ba7675a";